import { Stack } from "@mui/material";

import AppIconButton from "@/common/components/Button/AppIconButton";
import AppIcon from "@/common/components/Icons/AppIcon";

export interface ImageComparisonToolbarProps {
  isShowLabels: boolean;
  onToggleLabels: () => void;
  onResetSlider: () => void;
  onSwapSides: () => void;
  onOpenBeforeFullscreen: () => void;
  onOpenAfterFullscreen: () => void;
}

export default function ImageComparisonToolbar({
  isShowLabels,
  onToggleLabels,
  onResetSlider,
  onSwapSides,
  onOpenBeforeFullscreen,
  onOpenAfterFullscreen,
}: ImageComparisonToolbarProps) {
  return (
    <Stack direction='row' spacing={0.5} sx={{ ml: "auto" }}>
      <AppIconButton
        size='small'
        tooltipProps={{ title: isShowLabels ? "Hide labels" : "Show labels" }}
        onClick={onToggleLabels}
      >
        <AppIcon of={isShowLabels ? "visibilityOff" : "visibility"} fontSize='small' />
      </AppIconButton>

      <AppIconButton size='small' tooltipProps={{ title: "Reset slider" }} onClick={onResetSlider}>
        <AppIcon of='refresh' fontSize='small' />
      </AppIconButton>

      <AppIconButton size='small' tooltipProps={{ title: "Swap sides" }} onClick={onSwapSides}>
        <AppIcon of='swapHoriz' fontSize='small' />
      </AppIconButton>

      <AppIconButton
        size='small'
        tooltipProps={{ title: "Fullscreen: Before" }}
        onClick={onOpenBeforeFullscreen}
      >
        <AppIcon of='openInNew' fontSize='small' />
      </AppIconButton>

      <AppIconButton
        size='small'
        tooltipProps={{ title: "Fullscreen: After" }}
        onClick={onOpenAfterFullscreen}
      >
        <AppIcon of='openInNew' fontSize='small' />
      </AppIconButton>
    </Stack>
  );
}
